interface ClickableMessageProps {
  isAreaSelectEnabled?: boolean;
  isClickable?: boolean;
}

export const ClickableMessage = ({
  isAreaSelectEnabled,
  isClickable
}: ClickableMessageProps) => {
  if (isAreaSelectEnabled) {
    return (
      <div className='mt-2 flex min-w-32 items-center'>
        <img src='/img/detective.svg' alt='detect' />
        <div
          className='ml-2 text-sm font-normal text-[#61656C]'
          data-testid='clickable'
        >
          Inspect metric
        </div>
      </div>
    );
  }

  return (
    <div className='mt-4 flex flex-col'>
      {isClickable && (
        <div className='mt-4 flex items-center'>
          <img src='/img/externalLink.svg' alt='link' />
          <div
            className='ml-2 mr-4 text-sm font-normal text-[#61656C]'
            data-testid='clickable'
          >
            Click chart to view in Activity
          </div>
        </div>
      )}
    </div>
  );
};

export default ClickableMessage;
